<template>
  <v-layout row wrap justify-space-between align-center py-4 pl-4>
    <v-flex
      :class="{ [`offset-md${parent.split('][').length - 1}`]: isChildren }"
      class="text-xs-center"
      :md1="!isChildren"
      :md2="isChildren">
      <v-icon v-if="isChildren" slot="icon" class="k-orange-linear-text" size="50">
        subdirectory_arrow_right
      </v-icon>
      <v-avatar size="50">
        <v-icon class="k-orange-linear" size="30">
          {{ intention.icon }}
        </v-icon>
      </v-avatar>
    </v-flex>
    <v-flex>
      <h2>
        {{ intention.title }}
      </h2>
      <div class="truncate">
        {{ intention.data.text || 'Escriba aqui un texto...' }}
      </div>
    </v-flex>
    <v-flex class="text-xs-right" mr-4 :md1="!intention.options" :md2="intention.options">
      <v-btn flat icon @click.stop="$emit('edit', { intention, parent })">
        <v-icon small color="black">
          fas fa-pencil-alt
        </v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    intention: {
      type: Object,
      required: true,
    },
    isChildren: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped>
.truncate {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-style: italic;
  color: #737373;
}
</style>


// WEBPACK FOOTER //
// src/components/bot_v4/Detail/IntentCard.vue